import { I18n } from 'react-redux-i18n';
import ServerUtils from '../../data/server';
import { axiosInstance } from '../initialization';
import AuthService from './auth';
import { I18nLanguages } from './i18n';
import { store } from '../../config/configureStore';

async function request(method, uri, data = {}, headers = {}, extras = {}) {
  if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';

  const { returnFullResponse, ...axiosExtras } = extras;

  try {
    const response = await axiosInstance({
      method,
      url: `${ServerUtils.getBaseUrl()}${uri}`,
      data,
      headers,
      ...axiosExtras,
    });

    if (returnFullResponse) {
      return response;
    }

    if (response && response.data) {
      if (response.data.data) return response.data.data;
      if (response.data.success) return null;
      return response.data;
    }
    return response;
  } catch (err) {
    if (err.response && err.response.data && err.response.data.error && err.response.data.error.translateObject) {
      const { translateObject = {} } = err.response.data.error;
      const { key = '', replacements = {} } = translateObject;

      if (key) {
        const translatedMessage = I18n.t(key, replacements);

        err.response.data.error.details = translatedMessage;
        err.response.data.error.message = translatedMessage;
      }
    }
    throw err;
  }
}

function publicHeader(header = {}) {
  header.Authorization = 'Basic YmVlc3RvY2t3ZWI6YmVlc3RvY2t3ZWJkZXNlbnZvbHZpZG9wb3JzenNvbHVjb2Vz';
  header['Content-Type'] = 'application/x-www-form-urlencoded';
  return header;
}

function urlencodedTrans(data) {
  const str = [];
  const keys = Object.keys(data);
  keys.forEach((key) => { str.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`); });
  return str.join('&');
}

function setDataAppLanguage(data = {}) {
  const { locale } = store.getState().app || {};
  if (locale) {
    data.appLanguage = I18nLanguages(locale);
  }
}

async function getRest(uri, data, header, extras) {
  setDataAppLanguage(data);
  return request('get', `${uri}${data ? `?${urlencodedTrans(data)}` : ''}`, {}, header, extras);
}

async function postRest(uri, data, header, extras) {
  setDataAppLanguage(data);
  const params = new URLSearchParams(data);
  return request('post', uri, params, publicHeader(header), extras);
}

async function putRest(uri, data, header, extras) {
  setDataAppLanguage(data);
  const params = new URLSearchParams(data);
  return request('put', uri, params, publicHeader(header), extras);
}

function authenticatedHeader(header = {}) {
  const auth = AuthService.get();
  if (auth) header.Authorization = `Bearer ${auth.access_token}`;
  return header;
}

async function getAuthenticated(uri, data, header, extras) {
  setDataAppLanguage(data);
  return request('get', `${uri}${data ? `?${urlencodedTrans(data)}` : ''}`, {}, authenticatedHeader(header), extras);
}

async function postAuthenticated(uri, data, header, extras) {
  setDataAppLanguage(data);
  return request('post', uri, data, authenticatedHeader(header), extras);
}

async function putAuthenticated(uri, data, header, extras) {
  setDataAppLanguage(data);
  return request('put', uri, data, authenticatedHeader(header), extras);
}

async function deleteAuthenticated(uri, data, header, extras) {
  setDataAppLanguage(data);
  return request('delete', uri, data, authenticatedHeader(header), extras);
}

export default {
  getRest,
  postRest,
  putRest,
  getAuthenticated,
  postAuthenticated,
  putAuthenticated,
  deleteAuthenticated,
};
